import React, { useEffect } from 'react'
import { Link } from 'react-router-dom';
import PharmacyHeading from '../PharmacyHeading'
import { FeaturedData } from '../Card/data';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import Heading from '../../Fashion/Heading';
import './style.css'
import { Carousel } from '3d-react-carousal';
import { useTranslation} from 'react-i18next';

const HotItems = (props) => {
    const { t, i18n } = useTranslation();
    //  slides = [
    //     <img  src="https://picsum.photos/300/300/?random" alt="1" />,
    //     <img  src="https://picsum.photos/300/301/?random" alt="2" />  ,
    //     <img  src="https://picsum.photos/300/302/?random" alt="3" />  ,
    //     <img  src="https://picsum.photos/300/303/?random" alt="4" />  ,
    //     <img src="https://picsum.photos/300/304/?random" alt="5" />   ];


    const callback = function (index) {
        console.log("callback", index);
    }
    return (
        <>
            <section id="pharmacy_hot_item" className="py-5 slider_arrows_one">
                <div className="container">
                    <Heading heading={t('beforenafter')} para={t('beforenaftersubheading')} />
                    <div className="row">
                        <div className="col-lg-12" style={{minHeight:270}}>

                            <Carousel slides={props.slides} autoplay={false} interval={1000} onSlideChange={callback} />

                        </div>
                    </div>

                    <div className='text-center'>
                    <Link to={{ pathname: `/before-after` }} className='btn btn-warning font-weight-light mt-5'>{t('viewallbeforenafter')}</Link>
                 
                    </div>
                </div>
            </section>
        </>
    )
}

export default HotItems